<template>
  <v-sheet  color="transparent">
    <div class="d-flex header justify-space-between">
      <h5 class="font-weight-bold">Cash List</h5>
      <div class="filter">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              class="p-0 btn-link"
              v-bind="attrs"
              v-on="on"
            >
              {{sortValue ? sortValue : 'sort By'}}  <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in itemsFilter"
              :key="index"
            >
              <v-list-item-title @click="sortBy(item.value)">{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="text-center py-10" 
      v-if="loader">
        <v-progress-circular
          indeterminate
          class="text-center"
          :size="50"
          color="primary"
        ></v-progress-circular>
    </div>
    <v-sheet v-else class="lists-card pb-10" color="transparent">
      <div v-if="convertReceipt(receipts).length > 0">
        <v-card
        ripple
        @click="getDetail(item.id)"
        class="mx-auto mt-3"
        rounded="0"
        flat
        v-for="(item , key) in convertReceipt(receipts)"
        :key="key"
      >
        <v-list-item class="p-0 elevation-3 rounded-lg overflow-hidden" three-line>
          <div class="pa-3 soft-grey mr-4">
            <v-icon size="100" class="white--text">mdi-cash</v-icon>
          </div>
          <v-list-item-content class="p-0">
            <div>
              <v-chip
                small
                class="mt-2"
                :class="item.status == 0 ? 'fade-in' : ''"
                :color="item.status == 0 ? 'red' : (item.status == 1? 'green' : 'black')"
                text-color="white"
              >
                {{item.status == 0 ? 'Need Approval' : (item.status == 1? 'Approved' : 'Ditolak')}}
              </v-chip>
            </div>
            <h4 class="p-0 font-weight-bold my-1">
              {{item.sender.name}}
            </h4>
            <v-list-item-subtitle class="p-0 font-weight-black">{{convertDate(item.cash_receipt.date)}} </v-list-item-subtitle>
            <v-list-item-subtitle class="p-0">Rp.{{convert(item.cash_receipt.amount)}},00 | <span class="text-uppercase">{{item.cash_receipt.payment_type}}</span></v-list-item-subtitle>
          </v-list-item-content >
        </v-list-item>
        </v-card>
      </div>
      <div class="text-center mt-10" v-else>
        <v-icon class="primary-color mb-4" :size="50">mdi-clipboard-file-outline</v-icon>
        <h5 class="mb-4">Belum ada data voucher {{homepage ? 'pending' : ''}}</h5>
      </div>

    </v-sheet>
  </v-sheet>
</template>

<script>
import numeral from 'numeral'
import { mapActions , mapGetters } from 'vuex'
export default {
  name : 'CardLists',
  data () {
    return {
      itemsFilter: [
        { title: 'Newest', value : 'newest' },
        { title: 'Latest', value : 'latest' },
      ],
      sortValue : '',
      datas : []
    }
  },
  props : ['receipts' , 'homepage'],
  mounted () {
    this.datas = this.receipts
  },
  computed : {
    ...mapGetters({
      loader : 'Global/loader'
    })
  },
  methods : {
    ...mapActions({
      getReceiptDetail : 'Forms/getReceiptDetail'
    }),
    getDetail(id){
      this.getReceiptDetail(id)
    },
    sortBy (value) {
      if(this.sortValue != value){
        this.receipts.reverse()
      }
      this.sortValue = value
    },
    convert(number){
      return numeral(number).format('0,0')
    },
    convertReceipt(receipt){
        var array = [];
        if(this.homepage){
          for (let index = 0; index < this.receipts.length; index++) {
            if(this.receipts[index].status == 0){
              array.push(this.receipts[index] )
            }  
          }
        } else {
          array = this.receipts
        }
        return array
    },
    convertDate (date) {
      var date_actual = new Date(date)
      date_actual = date_actual.getDate() + ' ' + this.getMonth(date_actual.getMonth()) + ' ' + date_actual.getFullYear()
      return  date_actual
    },
    getMonth (month) {
      month++
      switch (month) {
        case 1:
          return "Januari";
          break;
        case 2:
          return "Februari";
          break;
        case 3:
          return "Maret";
          break;
        case 4:
          return "April";
          break;
        case 5:
          return "Mei";
          break;
        case 6:
          return "Juni";
          break;
        case 7:
          return "Juli";
          break;
        case 8:
          return "Agustus";
          break;
        case 9:
          return "September";
          break;
        case 10:
          return "Oktober";
          break;
        case 11:
          return "November";
          break;
        case 12:
          return "Desember";
          break;
        default:
          return 
          break;
      }
    }
  }
}
</script>

<style scoped>
.btn-link {
  background :  unset !important;
  color : black !important;
  text-transform: capitalize !important;
  box-shadow: none !important;
  padding: 0 !important;
  height :fit-content !important
}
.v-list--three-line .v-list-item .v-list-item__content, .v-list-item--three-line .v-list-item__content {
  align-self: unset !important;
}
/* .lists-card {
  overflow-y : scroll !important;
  height : 85vw;
} */

</style>